// extracted by mini-css-extract-plugin
export default {"wrapper":"DiagnosticsPage_wrapper__lAzaf","collapseList":"DiagnosticsPage_collapseList__T3cpZ","listTitle":"DiagnosticsPage_listTitle__pTjoh"};